import * as React from "react";
import type { SvyRadioProps } from "./SvyRadio.interface";
import { RadioGroupIndicatorIcon } from "./SvyRadio.style";
import { withLabel } from "@/helpers/withLabel";

export const InnerSvyRadio = React.forwardRef<HTMLSpanElement, SvyRadioProps>(({ checked, ...props }, ref) => (
    <RadioGroupIndicatorIcon
        ref={ref}
        data-testid={checked ? "svy-radio-checked" : "svy-radio-not-checked"}
        checked={checked}
        icon={checked ? "radio-button-fill" : "checkbox-blank-circle-line"}
        aria-label={props.id}
        {...props}
    />
));

InnerSvyRadio.displayName = "SvyRadio";

export const SvyRadio = withLabel(InnerSvyRadio, { orientation: "horizontal-reverse" });
